var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "banner-autoeficacia text-white mb-2"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "md": "4"
    }
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "FileTextIcon",
      "size": "32"
    }
  }), _c('h1', {
    staticClass: "text-white mb-0"
  }, [_vm._v("Painel de Autoeficácia")])], 1), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.fetchReport.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge border-0 shadow-sm rounded-pill bg-white px-1"
  }, [_c('b-input-group-prepend', {
    staticClass: "bg-transparent border-0",
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    staticClass: "text-muted",
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    staticClass: "border-0 shadow-none bg-transparent py-2",
    attrs: {
      "placeholder": "Buscar por Nome do Aluno"
    },
    on: {
      "input": _vm.debouncedFetch
    },
    model: {
      value: _vm.filters.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "search", $$v);
      },
      expression: "filters.search"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-2 px-1"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap gap-2"
  }, [_c('b-form-select', {
    staticClass: "filter-select mr-1 mb-1",
    attrs: {
      "options": _vm.options.anoLetivo
    },
    on: {
      "change": _vm.fetchReport
    },
    model: {
      value: _vm.filters.anoLetivo,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "anoLetivo", $$v);
      },
      expression: "filters.anoLetivo"
    }
  }), _c('b-form-select', {
    staticClass: "filter-select mr-1 mb-1",
    attrs: {
      "options": _vm.options.municipio
    },
    on: {
      "change": _vm.fetchReport
    },
    model: {
      value: _vm.filters.municipio,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "municipio", $$v);
      },
      expression: "filters.municipio"
    }
  }), _c('b-form-select', {
    staticClass: "filter-select mr-1 mb-1",
    attrs: {
      "options": _vm.options.bairro
    },
    on: {
      "change": _vm.fetchReport
    },
    model: {
      value: _vm.filters.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "bairro", $$v);
      },
      expression: "filters.bairro"
    }
  }), _c('b-form-select', {
    staticClass: "filter-select mr-1 mb-1",
    attrs: {
      "options": _vm.options.escola
    },
    on: {
      "change": _vm.fetchReport
    },
    model: {
      value: _vm.filters.escola,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "escola", $$v);
      },
      expression: "filters.escola"
    }
  }), _c('b-form-select', {
    staticClass: "filter-select mr-1 mb-1",
    attrs: {
      "options": _vm.options.turma
    },
    on: {
      "change": _vm.fetchReport
    },
    model: {
      value: _vm.filters.turma,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "turma", $$v);
      },
      expression: "filters.turma"
    }
  }), _c('b-button', {
    staticClass: "mb-1",
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v(" Limpar Filtros ")])], 1)]), _c('b-tabs', {
    staticClass: "autoeficacia-tabs",
    attrs: {
      "content-class": "mt-1",
      "pills": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "PieChartIcon",
            "size": "16"
          }
        }), _c('span', [_vm._v("Visão Geral")])];
      },
      proxy: true
    }])
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "mb-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', {
    staticClass: "text-primary-green mb-0"
  }, [_vm._v("Score geral por escola")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Média das Somas")])]), _vm.reportData.mediaGeral ? _c('div', {
    staticClass: "h2 text-primary-green font-weight-bolder"
  }, [_vm._v(" " + _vm._s(_vm.reportData.mediaGeral.toFixed(1)) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "chart-wrapper mt-3"
  }, [_c('div', {
    staticClass: "y-axis-label text-muted"
  }, [_vm._v("Score")]), _c('vue-apex-charts', {
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.barChartOptions,
      "series": _vm.barChartSeries
    }
  })], 1)])], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "mb-2"
  }, [_c('h3', {
    staticClass: "text-primary-green mb-0"
  }, [_vm._v("Recentes")])]), _c('b-table', {
    staticClass: "mt-1 autoeficacia-table",
    attrs: {
      "items": _vm.reportData.resultadosPorAluno.slice(0, 10),
      "fields": _vm.tableFields.filter(function (f) {
        return f.key !== 'schoolName';
      }),
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(autoeficacia)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "font-weight-bold text-center d-block text-primary-green"
        }, [_vm._v(_vm._s((data.value || 0).toFixed(1)))])];
      }
    }])
  })], 1)], 1)], 1)], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "UserIcon",
            "size": "16"
          }
        }), _c('span', [_vm._v("Ranking por Aluno")])];
      },
      proxy: true
    }])
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h3', {
    staticClass: "text-primary-green mb-0"
  }, [_vm._v("Ranking Geral de Alunos")])]), _c('b-table', {
    staticClass: "autoeficacia-table",
    attrs: {
      "items": _vm.sortedStudents,
      "fields": _vm.rankingStudentFields,
      "per-page": _vm.perPage,
      "current-page": _vm.rankingStudentCurrentPage,
      "responsive": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(posicao)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("#" + _vm._s((_vm.rankingStudentCurrentPage - 1) * _vm.perPage + data.index + 1))])];
      }
    }, {
      key: "cell(autoeficacia)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "px-1 py-50",
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(" " + _vm._s((data.value || 0).toFixed(1)) + " ")])];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-1"
  }, [_c('span', {
    staticClass: "text-muted small"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.sortedStudents.length > 0 ? (_vm.rankingStudentCurrentPage - 1) * _vm.perPage + 1 : 0) + " a " + _vm._s(Math.min(_vm.rankingStudentCurrentPage * _vm.perPage, _vm.sortedStudents.length)) + " de " + _vm._s(_vm.sortedStudents.length) + " alunos ")]), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.sortedStudents.length,
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.rankingStudentCurrentPage,
      callback: function callback($$v) {
        _vm.rankingStudentCurrentPage = $$v;
      },
      expression: "rankingStudentCurrentPage"
    }
  })], 1)], 1)], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "UsersIcon",
            "size": "16"
          }
        }), _c('span', [_vm._v("Ranking por Turma")])];
      },
      proxy: true
    }])
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h3', {
    staticClass: "text-primary-green mb-0"
  }, [_vm._v("Ranking Geral de Turmas")])]), _c('b-table', {
    staticClass: "autoeficacia-table",
    attrs: {
      "items": _vm.sortedClassrooms,
      "fields": _vm.rankingClassroomFields,
      "per-page": _vm.perPage,
      "current-page": _vm.rankingClassroomCurrentPage,
      "responsive": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(posicao)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("#" + _vm._s((_vm.rankingClassroomCurrentPage - 1) * _vm.perPage + data.index + 1))])];
      }
    }, {
      key: "cell(average)",
      fn: function fn(data) {
        return [_c('b-badge', {
          staticClass: "px-1 py-50",
          attrs: {
            "pill": "",
            "variant": "light-success"
          }
        }, [_vm._v(" " + _vm._s((data.value || 0).toFixed(1)) + " ")])];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-1"
  }, [_c('span', {
    staticClass: "text-muted small"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.sortedClassrooms.length > 0 ? (_vm.rankingClassroomCurrentPage - 1) * _vm.perPage + 1 : 0) + " a " + _vm._s(Math.min(_vm.rankingClassroomCurrentPage * _vm.perPage, _vm.sortedClassrooms.length)) + " de " + _vm._s(_vm.sortedClassrooms.length) + " turmas ")]), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.sortedClassrooms.length,
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.rankingClassroomCurrentPage,
      callback: function callback($$v) {
        _vm.rankingClassroomCurrentPage = $$v;
      },
      expression: "rankingClassroomCurrentPage"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }